import { Catalogue } from "../components/Catalogue";
import { Footer } from "../components/Footer";

export const ProductsPage = ({ categories, activeCat, setActiveCat, loading, query, setQuery, onSelect }) => (
  <div className="grain bg-[#FAF8FC] text-[#221533] min-h-screen" data-testid="products-page">
    <div className="pt-[70px]">
      <Catalogue
        categories={categories}
        activeCat={activeCat}
        setActiveCat={setActiveCat}
        loading={loading}
        query={query}
        setQuery={setQuery}
      />
    </div>
    <Footer onSelect={onSelect} />
  </div>
);
